import queryString from 'query-string';
import * as actionTypes from './types';
import { endpoints } from '../../../api/endpoints';
import * as api from '../../../api/base';
import store from '../..';
import {
  dfltSuccessResponseAction,
  dfltFailResponseAction,
  dfltExceptionResponseAction
} from '../../utility'

export const getAllAdminAccounts = (params) => async (dispatch) => {
    try {
        const response = await api.get(endpoints.admin.user.accounts.concat('?', queryString.stringify(params)));
        if (response && response.status === 200) {
            return dispatch(getAllAdminAccountSuccess(response?.data));
        }
        else {
            return dispatch(dfltFailResponseAction(response));
        }
    } catch (e) {
        return dispatch(dfltExceptionResponseAction(e));
    }
};

const getAllAdminAccountSuccess = (response) => {
    return {
        type: actionTypes.GET_ALL_ADMIN_ACCOUNT_DATA_SUCCESS,
        payload: response
    };
};


export const getAdminAccountData = (accountId) => async (dispatch) => {
    const response = await api.get(endpoints.admin.user.account.concat(accountId));
    if (response && response.status === 200) {
        return dispatch(getAdminAccountDataSuccess(response.data));
    }
    else {
         return dispatch(dfltFailResponseAction(response));
    }
};

const getAdminAccountDataSuccess = (response) => {
    return {
        type: actionTypes.GET_ADMIN_ACCOUNT_DATA_SUCCESS,
        payload: response
    };
};

export const setSelectedUserId = (userId) => {
    return {
        type: actionTypes.SET_ADMIN_ACCOUNT_USER_ID,
        payload: userId
    };
};

/**
 * Correct the roles list to include paid if user is consultant (AGC-2620)
 * TODO Fix this when we do Susbcription Management
 * 
 * @param {*} type user type
 */
const getCorrectedRoles = (type) =>{
    let roles=[type]
    if (type === 'consultant'){
        roles.push('paid')
    }
    return roles
}

export const createAdminAccount = (data) => async (dispatch) => {
    const {
        id,
        type,
        email,
        firstName,
        lastName,
        organisationId,
        officeId,
        license,
        active,
        newsletter,
        agreement,
    } = data;
    try {
        const response = await api.post(endpoints.admin.user.create,
            {
                // name: firstName,
                // surname: lastName,
                email: email,
                isActive: active,
                lockoutEnabled: true,
                firstName: firstName,
                lastName: lastName,
                roleNames: getCorrectedRoles(type),
                agreedToTandS: agreement,
                licenseId: license,
                officeId: officeId || null,
                optInNewsletter: newsletter,
                organisationId: organisationId || null
            });
        if (response && response.status === 200) {
            return dispatch(dfltSuccessResponseAction("User has been created successfully"));
        }
         else {
            return dispatch(dfltFailResponseAction(response));
        }
    } catch (e) {
        return dispatch(dfltExceptionResponseAction(e));
    }
};

export const updateAdminAccount = (data) => async (dispatch) => {
    const {
        id,
        type,
        email,
        firstName,
        lastName,
        organisationId,
        officeId,
        license,
        active,
        newsletter,
        agreement,
    } = data;
    try {
        const response = await api.put(endpoints.admin.user.account.concat(id),
            {
                // name: firstName,
                // surname: lastName,
                email: email,
                isActive: active,
                lockoutEnabled: true,
                firstName: firstName,
                lastName: lastName,
                roleNames: getCorrectedRoles(type),
                agreedToTandS: agreement,
                licenseId: license,
                officeId: officeId || null,
                optInNewsletter: newsletter,
                organisationId: organisationId || null,

            });
        if (response && response.status === 200) {
            return dispatch(dfltSuccessResponseAction("User has been updated successfully"));
        }
        else {
            return dispatch(dfltFailResponseAction(response));
        }
    } catch (e) {
        return dispatch(dfltExceptionResponseAction(e));
    }
};

export const deleteAdminAccount = (data) => async (dispatch) => {
    const { selectedUserId } = store.getState().adminAccount;
    const response = await api.del(endpoints.admin.user.account.concat(selectedUserId));
    if (response && (response.status === 200 || response.status === 204)) {
        return dispatch(dfltSuccessResponseAction("Successfully deleted the user"));
    }
    else {
            return dispatch(dfltFailResponseAction(response));
    }
};
